import React from "react";

import { Radio } from "../../atoms";

const renderRadioOptions = props => {

	const { options, checks, changeAction, value, align, name, id } = props;
	return options.map((o, i) =>
		<Radio
			key={o.id}
			id={id || id === 0 ? Math.random() : o.id}
			label={o.label}
			checked={value == o.id}
			changeAction={changeAction}
			value={o.id}
			align={align}
			name={name}
		/>
	);
};

export const RadioMolecule = props => {
	const isIE = false || !!document.documentMode;
	return (
		<div className={`radio-molecule ${isIE ? "ie-display flex -v" : "flex -v"}`}>
			<label>{props.label}</label>
			{renderRadioOptions(props)}
		</div>
	);
};


// WEBPACK FOOTER //
// src/molecules/lib/RadioMolecule.js